
const  csharp = `
using System.Net.WebSockets;
using System.Text;
using System.IO.Compression;

class Program
{
    private static readonly string WebSocketUrl = "wss://open-api-swap.bingx.com/swap-market?listenKey=425f783f4a17cd65f4a5d7470cfd45a956dba0c29564aa4b70967bee4e4a8984";
    private static readonly string Channel = "https://open-api.bingx.com/openApi/user/auth/userDataStream";

    static async Task Main(string[] args)
    {
        using (var client = new ClientWebSocket())
        {
            try
            {
                await client.ConnectAsync(new Uri(WebSocketUrl), CancellationToken.None);
                Console.WriteLine("WebSocket connected");

                // Send channel subscription message
                var message = Encoding.UTF8.GetBytes(Channel);
                await client.SendAsync(new ArraySegment<byte>(message), WebSocketMessageType.Text, true, CancellationToken.None);
                Console.WriteLine("Subscription message sent");

                var buffer = new byte[1024 * 4];
                while (client.State == WebSocketState.Open)
                {
                    WebSocketReceiveResult result = await client.ReceiveAsync(new ArraySegment<byte>(buffer), CancellationToken.None);

                    // Handle the received data
                    if (result.MessageType == WebSocketMessageType.Close)
                    {
                        Console.WriteLine("Connection closed");
                        break;
                    }

                    string receivedMessage = HandleReceivedMessage(buffer, result.Count);
                    Console.WriteLine("Received message: " + receivedMessage);

                    if (receivedMessage.Contains("ping"))  
                    {
                        var pongMessage = Encoding.UTF8.GetBytes("pong");
                        await client.SendAsync(new ArraySegment<byte>(pongMessage), WebSocketMessageType.Text, true, CancellationToken.None);
                        Console.WriteLine("Sent pong");
                    }
                }
            }
            catch (Exception ex)
            {
                Console.WriteLine($"WebSocket Exception: {ex.Message}");
            }
        }
    }

    private static string HandleReceivedMessage(byte[] buffer, int length)
    {
        // Assuming the message might be compressed
        byte[] data = new byte[length];
        Array.Copy(buffer, data, length);
        
        try
        {
            // Try to decompress if it's a GZIP compressed message
            string decompressedMessage = DecompressGzip(data);
            return decompressedMessage;
        }
        catch (Exception)
        {
            // If decompression fails, assume it's a plain text message
            return Encoding.UTF8.GetString(data);
        }
    }

    private static string DecompressGzip(byte[] compressedData)
    {
        using (var input = new MemoryStream(compressedData))
        using (var gzip = new GZipStream(input, CompressionMode.Decompress))
        using (var reader = new StreamReader(gzip, Encoding.UTF8))
        {
            return reader.ReadToEnd();
        }
    }
}`
export default  csharp



// WEBPACK FOOTER //
// ./src/utils/codeWs/spot/csharp.js